<script>
import {isvalidPhone} from "@/utils/validate";
import moment from "moment";
import {selectUserInfoByMobile} from "@/api/enterpriseServiceActivitiesManagement";

export default {
  name: 'OperationForm',
  props: {
    operationData: {
      type: Object,
      default: {}
    },
    operationType: {
      type: String,
      default: 'add'
    }
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
       form: {
        // 手机号
        phoneNumber: '',
        // 用户id
        userId: '',
        // 姓名/昵称
        userName: '',
         // 原因
         reason: '',
      },
      rules: {
        phoneNumber: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { required: true, validator: isvalidPhone, trigger: 'blur' }
        ],
      },
    }
  },
  created() {
    if (this.operationType === 'edit') {
      this.form ={
        // 手机号
        phoneNumber: this.operationData.phoneNumber,
        // 用户id
        userId:  this.operationData.userId,
        // 姓名/昵称
        userName:  this.operationData.userName,
         // 原因
        reason:  this.operationData.reason,
        id: this.operationData.id,
      }
    }
  },
  methods: {
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.addVerificationAndSign()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
    /**
     * @Description：通过手机号查询用户信息
     * @Author cxd
     * @Date 2026/1/6 09:34
     */
    async searchByPhoneNumber() {
      const res = await selectUserInfoByMobile(this.form.phoneNumber)
      const { code, data, msg } = res
      if (code === 200) {
        this.form.userName = data.nickname
        this.form.userId = data.userId
      } else {
        this.$message.error(msg)
      }
    },
    /**
     * @Description：添加
     * @Author cxd
     * @Date 2026/1/12 14:59
     */
    async addVerificationAndSign() {
      const params = {
        ...this.form,
      }
      if (!this.form.userId || !this.form.userName) {
        this.$message.warn('请点击查询按钮确定要添加的用户信息！')
        return
      }
      this.$emit('addVerificationAndSign', params)
    },
    /**
     * @Description：手机号change事件
     * @Author cxd
     * @Date 2026/1/14 15:21
     */
    handleMobileChange() {
      this.form.userId = ''
      this.form.userName = ''
    }
  }
}
</script>

<template>
  <div>
    <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
    >
     <a-row type="flex" align="middle">
       <a-col :span="20">
         <a-form-model-item label="手机号" prop="phoneNumber">
           <a-input :style="{ width: '330px' }" @change="handleMobileChange" :disabled="this.operationType === 'edit'" :maxLength="11" v-model.trim="form.phoneNumber" placeholder="请输入手机号" />
         </a-form-model-item>
       </a-col>
       <a-col :span="4">
         <a-button type="primary" :disabled="this.operationType === 'edit'" @click="searchByPhoneNumber">查询</a-button>
       </a-col>
     </a-row>
      <a-form-model-item label="用户id" prop="userId">
        {{ form.userId }}
      </a-form-model-item>
      <a-form-model-item label="姓名/昵称" prop="userName">
        {{ form.userName }}
      </a-form-model-item>
      <a-form-model-item label="原因" prop="reason">
        <a-textarea
            :style="{ width: '360px' }"
            placeholder="请输入原因"
            :rows="3"
            v-model.trim="form.reason"
            :maxLength="100"
        />
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<style scoped lang="scss">
.ant-form-item {
  margin: 0!important;
}
</style>